import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import vuetify from './plugins/vuetify'
import './plugins/global-components'
import './plugins/global-validations'
import StoreMixin from '@/mixins/store.mixin'
import LogRocket from 'logrocket'

if (process.env.ENVIRONMENT !== 'development') LogRocket.init('uotsmx/wgplanmapping')

Vue.config.productionTip = false
Vue.prototype.$routes = router.options.routes

Vue.mixin(StoreMixin)

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
